import { FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, Icon, CircularProgress, Tooltip, FormHelperText, Fade } from "@mui/material";
import { useState, memo, useEffect } from "react";

export interface INombreCarpetaInput {
    nombre: string;
    onPressSave: (entrada: string) => Promise<void>;
    editable: boolean;
    label?: string;
    successMessage?: string;
}

const NombreEditableInput = ({ label, nombre: pNombre, onPressSave, editable, successMessage }: INombreCarpetaInput) => {
    const [isSaving, setIsSaving] = useState(false);
    const [nombre, setNombre] = useState(pNombre);
    const [showHelperText, setShowHelperText] = useState(false);

    const handleOnSave = () => {
        setIsSaving(true);
        onPressSave(nombre)
            .then(() => {
                setIsSaving(false);
                setShowHelperText(true);
                setTimeout(() => setShowHelperText(false), 5000);
            })
            .catch(() => setIsSaving(false));
    };

    useEffect(() => {
        if (showHelperText) {
            const timer = setTimeout(() => setShowHelperText(false), 3000);
            return () => clearTimeout(timer);
        }
    }, [showHelperText]);

    return editable ? (
        <Tooltip title={pNombre} placement="top">
            <FormControl sx={{ m: 1, width: '35ch' }} variant="outlined" size="small">
                <InputLabel size="small">{label}</InputLabel>
                <OutlinedInput
                    type='text'
                    size='small'
                    value={nombre || ''}
                    onChange={(e) => setNombre(e.target.value || '')}
                    endAdornment={
                        <InputAdornment position="end">
                            {isSaving ? <CircularProgress sx={{ width: '25px!important', height: '25px!important' }} /> : <IconButton
                                sx={{ display: nombre !== pNombre ? 'block' : 'none' }}
                                size="small"
                                aria-label="edit entrada"
                                onClick={handleOnSave}
                                edge="end"
                            >
                                <Icon>save</Icon>
                            </IconButton>}
                        </InputAdornment>
                    }
                    label={label}
                />
                <Fade in={showHelperText} timeout={{ enter: 500, exit: 1000 }}>
                    <FormHelperText sx={{ color: 'green' }}>
                        {successMessage ?? 'Nombre editado con éxito'}
                    </FormHelperText>
                </Fade>
            </FormControl>
        </Tooltip>
    ) : (
        <Tooltip title={pNombre} placement="top">
            <span>{nombre}</span>
        </Tooltip>
    );
};

export default memo(NombreEditableInput, (prevProps, nextProps) => {
    return prevProps.nombre === nextProps.nombre && prevProps.editable === nextProps.editable
        && prevProps.onPressSave === nextProps.onPressSave;
});
